module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add slide":"Add slide","slide name":"Slide name","enter slide name":"Please enter slide name.","soft limit slides reached":"The recommenden number of slides ({limit}) is exceeded..."}}')
  delete Component.options._Ctor
}
